import { render, staticRenderFns } from "./stored-value-use-recored.vue?vue&type=template&id=1c45aeaa"
import script from "./stored-value-use-recored.vue?vue&type=script&lang=js"
export * from "./stored-value-use-recored.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports